import React, {useContext} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";

import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Button from "@mui/material/Button";

import {getCurrentGroups} from "./lookWizardFunctions";
import {setWizardActiveStep} from "../../../../../actions/wizardFunctions";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {getLookIdUrl} from "../../lookFunctions2";
import {setCanvasScale} from "../../../../../actions/actionFunctions";
import {zoomCanvasOut} from "../../lookFunctions";
import LookCanvasContext from "../../../lookCanvasContext";
import LookWizardContext from "./lookWizardContext";

const LookWizardCompletedAlertModal = (props) => {

  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues, anchorEl, history, setCanvasScale, fabricatorData,
    wizardWasRestored} = props;

  const wizContext = useContext(LookWizardContext);

  if (!wizardActiveItem) {
    return null
  }

  const currentGroups = wizContext.currentGroups || getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);

  const closeWizardButtonClick = (imageCanvas) => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookWizardCompletedClose);
    zoomCanvasOut(imageCanvas, setCanvasScale);
    history.push(getLookIdUrl());
  }

  const isCompletedStep = wizardActiveStep > -1 && !currentGroups.length;

  return (
    <Popper open={isCompletedStep && !wizardWasRestored}
            className="lk-title__modal lw-alert"
            id={"style-modal"}
            anchorEl={anchorEl.current}
            placement={"right"}
            transition
            disablePortal={false}>
      {({ TransitionProps }) => (
        <Grow
          {...TransitionProps}
          style={{ transformOrigin: "left center" }}
        >
          <Paper className="lk-title__modal-paper lk-title__modal-paper--mobile-top">
            <div  className="lk-title__modal-paper-content">
              <h3 className="h3">
                <FormattedMessage id="wizard.completed.title" values={{wizardName: wizardActiveItem.name}}/>
              </h3>
              <p>
                <FormattedMessage id="wizard.completed.description.short" values={{wizardName: wizardActiveItem.name}}/>
              </p>
              <div className="text-right">
                <LookCanvasContext.Consumer>
                  {(imageCanvas) => (
                    <Button className={"look-button " + (fabricatorData.isAmericanStandard
                      ? "look-button--primary2" : "look-button--primary look-button--yellow")}
                            onClick={() => closeWizardButtonClick(imageCanvas)}>
                      <FormattedMessage id="wizard.completed.close"/>
                    </Button>
                  )}
                </LookCanvasContext.Consumer>
              </div>
            </div>
          </Paper>
        </Grow>
      )}
    </Popper>
  )
};

LookWizardCompletedAlertModal.propTypes = {
  anchorEl: PropTypes.object.isRequired,
}

const mapStateToProps = (store) => {
  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues, wizardWasRestored} = store.wizardState;

  return {
    wizardActiveItem,
    wizardActiveStep,
    wizardSelectedValues,
    wizardWasRestored,
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {
  setWizardActiveStep,
  setCanvasScale,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookWizardCompletedAlertModal)
)
